import * as React from 'react';
import { SearchBarProps } from '@vp/omnisearch';
import { CartTenantDetails } from '@vp/cart-client';
import { addScriptsToDocument, makeFileRequest, getHeaderKey } from './helpers';
import { BookendType, REACT_COMP_VERSION } from '../constants';

export interface HeaderProps {
  locale: string,
  type: BookendType,
  hideSearch?: boolean,
  hideVat?: boolean,
  showStickyHeader?: boolean,
  tenant: string
  searchBarProps?: SearchBarProps
  trackingConfiguration: TrackingConfiguration
  useMiniCart?: boolean
  MiniCartConfig?: {tenantDetails: CartTenantDetails}
  stagingContent?: boolean
}

const headerContainer = typeof document !== "undefined"
  ? document.getElementById("bookendsHeader")
  : null
const headerAddedOnEdge = headerContainer && headerContainer?.children?.length > 0
let header: string = headerAddedOnEdge && headerContainer ? headerContainer.innerHTML : ""
let headerScripts: {src: string, innerHTML: string}[]
let isSpaEntry = true

export const Header = (props: HeaderProps) => {
  const [isHeaderAdded, setIsHeaderAdded] = React.useState<boolean>(false)
  const [headerHtml, setHeaderHtml] = React.useState<string>(header)  
  const [bookendsScripts, setBookendsScripts] = React.useState<{src: string, innerHTML: string}[]>(headerScripts)
  let variation = 'default'

  if (typeof window !== "undefined") {
    window.bookends.SearchBarConfig = props.searchBarProps
    window.bookends.trackingConfiguration = props.trackingConfiguration
    window.bookends.useMiniCart = props.useMiniCart === undefined ? true : props.useMiniCart
    window.bookends.MiniCartConfig = props.MiniCartConfig
    if(window.bookendsHeaderVariation) {
      variation = window.bookendsHeaderVariation
    }
  }

  React.useEffect(() => {
    if ((headerAddedOnEdge || isHeaderAdded) && headerContainer) {
      const scripts = Array.from(headerContainer?.querySelectorAll("script")).map(
        script => {
          return {
            src: script.src,
            innerHTML: script.innerHTML.trim()
          }
        }
      )
      headerScripts = scripts
      if (!isHeaderAdded) {
        setIsHeaderAdded(true)
      }
    }
  },[])

  React.useEffect(() => {
    if ((!header && headerContainer?.children.length === 0) || (!headerContainer && isSpaEntry)) {
      const bundleScriptHtmlPromise = makeFileRequest(props.stagingContent, `/html/statics/dep-share/${REACT_COMP_VERSION}_bundle-script.html`)
      const headerHtmlPromise = makeFileRequest(props.stagingContent,
        `/esi/${REACT_COMP_VERSION}/${props.tenant}/${props.locale.toLowerCase()}/header/${props.type}/hidesearch-${props.hideSearch || false}_hidevat-${props.hideVat || false}/dep-share/${variation}-fullcomponent.html`)
      const parser = new DOMParser()
      Promise.all([bundleScriptHtmlPromise, headerHtmlPromise]).then(htmlResponse => {
        const tmpElement = parser.parseFromString(
          htmlResponse[1],
          "text/html"
        )
        const scriptElements = Array.from(
          tmpElement.querySelectorAll("script")
        )
        const scripts: any[] = [{
          src: undefined,
          innerHTML: htmlResponse[0].replace("<script>", "").replace("</script>", "").trim()
        }]
        scriptElements.forEach((scriptElement: any) => {
          scripts.push({
            src: scriptElement.src,
            innerHTML: scriptElement.innerHTML.trim()
          })
          tmpElement.body.removeChild(scriptElement)
        })
        setHeaderHtml(tmpElement.head.outerHTML + tmpElement.body.outerHTML)
        setBookendsScripts(scripts)

        isSpaEntry = false
        header = tmpElement.head.outerHTML + tmpElement.body.outerHTML
        headerScripts = scripts
      })
    }
  },[])

  React.useEffect(() => {
    const headerElement = document.getElementById(`${props.type}_header`)
    if (((!headerAddedOnEdge && !isHeaderAdded) || !isSpaEntry)
      && bookendsScripts
      && headerElement?.dataset?.hydrated !== "true"
    ) {
      if (
        !window.bundleInterval
        || !window[`${props.type}_header_componentWrapperInterval`]
      ) {
        let scriptsToAdd = bookendsScripts;
        if (window.bundleInterval) { //Prevent double loading bundleInterval
          scriptsToAdd = bookendsScripts.filter(script => !script.innerHTML.startsWith("var bundleInterval"))
        }
        addScriptsToDocument(scriptsToAdd)
      }
      if (
        window
        && window.ComponentWrapper
        && window.ComponentWrapper[`show_${props.type}_header`]
        && window[`${props.type}_header_props`]
      ) {
        window.ComponentWrapper[`show_${props.type}_header`](window[`${props.type}_header_props`])
      }
    }
  })

  return (
    <div
      id="bookendsHeader"
      data-headerkey={getHeaderKey(props.tenant, props.locale, props.type, props.hideSearch, props.hideVat, props.showStickyHeader)}
      dangerouslySetInnerHTML={{ __html: headerHtml }}
    />
  )
}